import { getAuth } from "firebase/auth";
import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface BlankHeaderParams {
  guestUser?: string;
}

const BlankHeader: React.FC<BlankHeaderParams> = ({ guestUser }) => {
  const { currentUser } = getAuth();
  const navigate = useNavigate();

  return (
    <div className="main_header flex justify-between">
      <div className="header_search">
        <div className="text-lg">
          <div>{guestUser && (<div>Hello, <span className="font-bold">{guestUser}</span></div>)}</div>
        </div>
      </div>
      {!currentUser &&<Button onClick={() => navigate('/')}> Log in</Button>}
    </div>
  );
};

export default BlankHeader;
